import React from 'react';
//import PropType from 'prop-types';
import ParallaxElement from '../common/ParallaxElement';

export default class Mage extends React.PureComponent {
    static propTypes = {
    };

    componentDidMount() {
        this.mageAnimation();
    }

    mageAnimation = () => {
        TweenMax.from(this.cape, 1, {
            y: 3, repeat: -1, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.body, 1, {
            y: 3, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.charmOne, 1, {
            rotation: -1, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.charmTwo, 1, {
            y: 3, rotation: 1, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.head, 1, {
            y: 3, rotation: 0.5, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.ponyTail, 1, {
            y: 3, rotation: 1, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.rightArm, 2, {
            y: 2, rotation: 3, repeat: -1, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.leftArm, 1, {
            y: 1, rotation: -1, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.effect, 10, {rotation: 360, repeat: -1, ease: Power0.easeNone});
        TweenMax.from(this.effectFront, 10, {
            rotation: -360, scale: 0.5, yoyo: true, repeat: -1, ease: Power0.easeNone
        });
    };

    render() {
        return (
            <ParallaxElement yStrength={0.2} stopY={-800} id="mage">
                <div className="mage-wrapper">
                    <div ref={(c) => {this.cape = c;}} className="mage cape" />
                    <div ref={(c) => {this.charmOne = c;}} className="mage ropeCharmOne" />
                    <div ref={(c) => {this.rightArm = c;}} className="mage rightArm" />
                    <div ref={(c) => {this.body = c;}} className="mage body" />
                    <div ref={(c) => {this.charmTwo = c;}} className="mage ropeCharmTwo" />
                    <div ref={(c) => {this.ponyTail = c;}} className="mage ponyTail" />
                    <div ref={(c) => {this.head = c;}} className="mage head" />
                    <div ref={(c) => {this.effect = c;}} className="mage effect" />
                    <div ref={(c) => {this.leftArm = c;}} className="mage leftArm" />
                    <div ref={(c) => {this.effectFront = c;}} className="mage effect front" />
                </div>
            </ParallaxElement>

        );
    }
}

